import { createContext, ReactElement, ReactNode, useCallback, useState } from 'react';

import { ResourceFragment as Resource, WorksheetFragment } from '@typing/Generated';
import { OpenerContextType, OpenerState, OpenerType } from '@typing/State';

// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
export const openerContext = createContext({} as OpenerContextType);

const initialState: OpenerState = Object.values(OpenerType).map(type => ({
  isOpen: false,
  record: undefined,
  type
}));

const OpenerStore = ({ children }: { children: ReactNode }): ReactElement => {
  const [openerState, setOpenerState] = useState(initialState);

  const toggleOpener = useCallback((type: OpenerType, isOpen: boolean, record?: Resource | WorksheetFragment) => {
    setOpenerState(prevState =>
      prevState.map(opener =>
        opener.type === type
          ? {
              ...opener,
              isOpen,
              record
            }
          : opener
      )
    );
  }, []);

  return <openerContext.Provider value={{ openerState, toggleOpener }}>{children}</openerContext.Provider>;
};

export default OpenerStore;
